import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
} from '@angular/core';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-slot-hold-timer',
  templateUrl: './slot-hold-timer.component.html',
  styleUrls: ['./slot-hold-timer.component.scss'],
  standalone: false,
})
export class SlotHoldTimerComponent implements OnChanges, OnDestroy {
  @Input() expiresAtMs: number;
  @Input() label: string = 'Time remaining:';
  @Input() hideWhenExpired = true;

  @Output() expired = new EventEmitter<void>();

  remainingSeconds = 0;
  display = '00:00';
  isExpired = false;

  private sub?: Subscription;
  private emittedExpired = false;

  ngOnChanges(changes: SimpleChanges): void {
    if ('expiresAtMs' in changes) {
      this.startOrStop();
    }
  }

  ngOnDestroy(): void {
    this.stop();
  }

  private startOrStop(): void {
    this.stop();
    this.emittedExpired = false;

    if (!this.expiresAtMs) {
      this.setExpiredState();
      return;
    }

    this.tick();

    this.sub = interval(1000).subscribe(() => this.tick());
  }

  private tick(): void {
    if (!this.expiresAtMs) return this.setExpiredState();

    const now = Date.now();
    const diffMs = this.expiresAtMs - now;

    const seconds = Math.max(0, Math.floor(diffMs / 1000));
    this.remainingSeconds = seconds;

    if (seconds <= 0) {
      this.setExpiredState();
      return;
    }

    this.isExpired = false;
    this.display = this.formatMMSS(seconds);
  }

  private setExpiredState(): void {
    this.remainingSeconds = 0;
    this.display = '00:00';
    this.isExpired = true;

    if (!this.emittedExpired) {
      this.emittedExpired = true;
      this.expired.emit();
    }

    this.stop();
  }

  private stop(): void {
    this.sub?.unsubscribe();
    this.sub = undefined;
  }

  private formatMMSS(totalSeconds: number): string {
    const mm = Math.floor(totalSeconds / 60);
    const ss = totalSeconds % 60;
    const mmStr = mm.toString().padStart(2, '0');
    const ssStr = ss.toString().padStart(2, '0');
    return `${mmStr}:${ssStr}`;
  }
}
